import { Component, ViewChild } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import {
  ContextMenuComponent,
  ContextMenuService,
} from "@perfectmemory/ngx-contextmenu";
import { ContextMenuOpenAtPositionOptions } from "@perfectmemory/ngx-contextmenu/lib/services/context-menu/context-menu.service";
@Component({
  selector: "external-mam-search-results-actions-cell",
  templateUrl: `./external-mam-search-results-actions-cell.component.html`,
  styleUrls: ["./external-mam-search-results-actions-cell.component.scss"],
})
export class ExternalMAMSearchResultsActionsCell
  implements ICellRendererAngularComp
{
  componentParent: any;
  id: number;
  imported: boolean;
  @ViewChild(ContextMenuComponent) public basicMenu;
  contextMenuOpen: boolean;

  constructor(
    private contextMenuService: ContextMenuService<ExternalMAMSearchResultsActionsCell>,
  ) {}
  agInit(params: ICellRendererParams): void {
    this.updateParams(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateParams(params);
    return true;
  }

  updateParams(params: ICellRendererParams) {
    if (!params?.data) {
      return;
    }
    this.id = params?.data?.id;
    this.imported = params?.data?.isEvrideoImported;
    this.componentParent = params?.context?.componentParent;
  }

  Import() {
    if (this.id) {
      this.componentParent.import([this.id]);
    }
  }
  UpdateMetadata() {
    if (this.id) {
      this.componentParent.updateItemMetadata([this.id]);
    }
  }

  onContextMenu($event: MouseEvent): void {
    this.contextMenuOpen = true;
    const pos = {
      value: this.basicMenu,
      x: $event.x,
      y: $event.y,
    } as ContextMenuOpenAtPositionOptions<any>;
    this.contextMenuService.closeAll();
    this.contextMenuService.show(this.basicMenu, pos);
    $event.preventDefault();
    $event.stopPropagation();
  }
}
